import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { HeaderFactoryService } from './header-factory.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AgentInfoService {

  webApiUrl: string;

  constructor(
    private _httpClient: HttpClient,
    private headerService: HeaderFactoryService,
    private configService: ConfigService
  ) { }

  updateAgentInfo(agentInfoModel: any): Observable<void> {

    return this._httpClient.put<void>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/Profile/updateAgentInformation`, agentInfoModel,
      this.headerService.getAuthorizationHeaderOptions()
    )
      .pipe(
        retry(3), catchError(this.errorHandler)
      );
  }

  errorHandler(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // error message for client-side or network error occurred if any.
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('UserProfile API may not be available; please try again later.');
  }
}
